import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import DropDown from "components/DropDown";
import { showMessage } from "components/Modal";
import AppNumberInput from "components/AppNumberInput";
import { LoadingButton } from "@mui/lab";
import { createCreditCardAction } from "redux/actions/cardActions";
import CloseIcon from "@mui/icons-material/Close";
import { toFixedWithoutZeros } from "constants/usefulFunctions";
import { EMAIL_REGEX } from "util/regex";
import { getWalletBalancesRequestAction } from "redux/actions/walletActions";
import { getAgentExchangeRateRequestAction } from "redux/actions/agentActions";

export const CreateCreditCard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { agentExchangeRate, walletBalances } = useSelector((state) => ({
    walletBalances: state.wallet.walletBalances,
    agentExchangeRate: state.agent.agentExchangeRate,
  }));
  const [english_first_name, setEnglishFirstName] = useState("");
  const [persian_first_name, setPersianFirstName] = useState("");
  const [english_last_name, setEnglishLastName] = useState("");
  const [persian_last_name, setPersianLastName] = useState("");
  const [currency, setCurrency] = useState("");
  const [amount, setAmount] = useState(0);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [errors, setErrors] = useState({});
  // const [isAmountEnabled, setIsAmountEnabled] = useState(false);

  useEffect(() => {
    dispatch(getWalletBalancesRequestAction());
    dispatch(getAgentExchangeRateRequestAction());
  }, []);

  const handleClose = () => {
    setShowConfirm(false);
  };

  const handleSubmit = () => {
    // if (handleValidation()) {
    setLoading(true);
    dispatch(
      createCreditCardAction({
        currency: currency.currency_id,
        amount,
        email,
        english_first_name,
        persian_first_name,
        english_last_name,
        persian_last_name,
        setLoading,
        onSuccess: () => {
          setShowConfirm(false);
          showMessage({
            status: "success",
            description:
              "Your virtual card has been created and sent to your email.",
            onSubmit: () => {
              navigate("/cards/virtual-cards");
            },
          });
        },
      })
    );
    // }
  };

  const handleEnglishChange = (setter) => (e) => {
    const value = e.target.value;
    const filteredValue = value.replace(/[^A-Za-z\s]/g, "");
    setter(filteredValue);
  };

  const handlePersianChange = (setter) => (e) => {
    const value = e.target.value;
    const filteredValue = value.replace(/[^آ-ی\s]/g, "");
    setter(filteredValue);
  };

  const renderDialogConfirm = (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={showConfirm}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Request New Virtual Card
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Typography gutterBottom>
          English First Name:{" "}
          <Typography sx={{ fontWeight: 500, display: "inline-block" }}>
            {english_first_name}
          </Typography>{" "}
        </Typography>
        <Typography gutterBottom>
          English Last Name:{" "}
          <Typography sx={{ fontWeight: 500, display: "inline-block" }}>
            {english_last_name}
          </Typography>{" "}
        </Typography>
        <Typography gutterBottom>
          Persian First Name:{" "}
          <Typography sx={{ fontWeight: 500, display: "inline-block" }}>
            {persian_first_name}
          </Typography>{" "}
        </Typography>
        <Typography gutterBottom>
          Persian Last Name:{" "}
          <Typography sx={{ fontWeight: 500, display: "inline-block" }}>
            {persian_last_name}
          </Typography>{" "}
        </Typography>
        <Typography gutterBottom>
          Email:{" "}
          <Typography sx={{ fontWeight: 500, display: "inline-block" }}>
            {email}
          </Typography>{" "}
        </Typography>

        {/* {isAmountEnabled && ( */}
        <>
          <Typography gutterBottom>
            Currency:{" "}
            <Typography sx={{ fontWeight: 500, display: "inline-block" }}>
              {currency.currency}
            </Typography>{" "}
          </Typography>
          <Typography gutterBottom>
            Amount:{" "}
            <Typography sx={{ fontWeight: 500, display: "inline-block" }}>
              {toFixedWithoutZeros(amount)}
            </Typography>
          </Typography>
        </>
        {/* )} */}
      </DialogContent>
      <DialogActions>
        <Button color="error" onClick={handleClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          sx={{ boxShadow: "none" }}
          // onClick={handleClose}
          onClick={handleSubmit}
          loading={loading}
        >
          Submit
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );

  return (
    <Grid container spacing={2}>
      {agentExchangeRate.map((rate) => (
        <Grid item xs={12} md={4}>
          <Card sx={{ borderRadius: 0 }}>
            <CardHeader title={rate.currency} />
            <CardContent>
              <Typography
                sx={{ display: "inline-block", fontWeight: 500, fontSize: 24 }}
              >
                {rate.amount}
              </Typography>{" "}
              IRR
            </CardContent>
          </Card>
        </Grid>
      ))}
      <Grid item xs={12}>
        <Card sx={{ borderRadius: 0 }}>
          <CardHeader title="Request New Virtual Card" />
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={3}>
                <TextField
                  label="First Name (English)"
                  onChange={handleEnglishChange(setEnglishFirstName)}
                  value={english_first_name}
                  fullWidth
                  // error={hasError && !!errors.email}
                  // helperText={hasError && errors.email || ""}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  label="Last Name (English)"
                  onChange={handleEnglishChange(setEnglishLastName)}
                  value={english_last_name}
                  fullWidth
                  // error={hasError && !!errors.email}
                  // helperText={hasError && errors.email || ""}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  dir="rtl"
                  label="First Name (Persian)"
                  onChange={handlePersianChange(setPersianFirstName)}
                  value={persian_first_name}
                  fullWidth
                  // error={hasError && !!errors.email}
                  // helperText={hasError && errors.email || ""}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  dir="rtl"
                  label="Last Name (Persian)"
                  onChange={handlePersianChange(setPersianLastName)}
                  value={persian_last_name}
                  fullWidth
                  // error={hasError && !!errors.email}
                  // helperText={hasError && errors.email || ""}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField
                  label="Email"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  fullWidth
                  error={errors.email}
                  helperText={errors.email}
                  onFocus={() => setErrors({})}
                />
              </Grid>

              {/* <Grid item xs={12}>
            <AppCheckbox
              label="Enable Amount"
              onChange={(e) => {
                console.log(e);
                setIsAmountEnabled(!isAmountEnabled);
              }}
              on
            />
          </Grid> */}
              {/* {isAmountEnabled && ( */}
              <>
                <Grid item xs={12} lg={3}>
                  <DropDown
                    label="Wallet"
                    schema={{ label: "currency", value: "currency_id" }}
                    items={walletBalances}
                    onChange={(event) => {
                      let id = event.target.value;
                      let currency = walletBalances.find(
                        (wallet) => wallet.currency_id === id
                      );
                      setCurrency(currency);
                    }}
                    value={currency.currency_id}
                    // error={hasError && !!errors.currency}
                    // helperText={hasError && errors.currency || ""}
                  />
                </Grid>

                {currency && (
                  <Grid item xs={12} lg={3}>
                    <AppNumberInput
                      thousandSeparator={true}
                      label="Amount"
                      onChange={(e) => setAmount(e.target.value)}
                      value={amount}
                      fullWidth
                      // error={hasError && !!errors.amount}
                      // helperText={hasError && errors.amount || ""}
                      helperText={`Balance: ${currency.balance} ${currency.currency}`}
                    />
                  </Grid>
                )}
              </>
            </Grid>
          </CardContent>
          <CardActions sx={{ justifyContent: "center" }}>
            <LoadingButton
              variant="contained"
              loading={loading}
              //onClick={handleSubmit}
              onClick={() => {
                if (!EMAIL_REGEX.test(email)) {
                  setErrors({
                    email: "The email address you entered is invalid.",
                  });
                  return;
                }
                setShowConfirm(true);
              }}
              disabled={
                !persian_first_name ||
                !persian_last_name ||
                !english_first_name ||
                !english_last_name ||
                !email ||
                !currency ||
                Number(amount) <= 0 ||
                currency.balance < Number(amount)
              }
            >
              Submit
            </LoadingButton>
          </CardActions>
          {renderDialogConfirm}
        </Card>
      </Grid>
    </Grid>
  );
};

export default CreateCreditCard;
